<template>
  <div>
    <div class="filters-section mb-4">
      <b-card class="">
        <b-card-header class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
              <i class="fas fa-filter mr-2"></i>Filters
          </h5>
          <div class="">
            <b-button variant="outline-primary" @click="exportReport('csv')" class="mr-2">
              <i class="fas fa-download mr-2"></i>Export CSV
            </b-button>
            <b-button variant="outline-secondary" @click="exportReport('pdf')">
              <i class="fas fa-file-pdf mr-2"></i>Export PDF
            </b-button>
          </div>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col md="2">
              <b-form-group label="Hotel:" label-for="hotel">
                <b-form-select
                  id="hotel"
                  v-model="filters.hotel_id"
                  :options="hotelOptions"
                  @change="fetchGuestList"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Check-in Date:" label-for="checkInDate1">
                <b-form-datepicker 
                  id="checkInDate1"
                  v-model="filters.check_in_date"
                  @input="fetchGuestList"
                  label="Date:"
                  class="date-picker" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Checkout Date:" label-for="checkoutDate1">
                <b-form-datepicker 
                  id="checkoutDate1"
                  v-model="filters.checkout_date"
                  @input="fetchGuestList"
                  label="Checkout Date:"
                  class="date-picker" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Pre Check-in Status:" label-for="preCheckInStatus">
                <b-form-select
                  id="preCheckInStatus"
                  v-model="filters.pre_check_in"
                  :options="preCheckInStatuses"
                  @change="fetchGuestList"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
    <div class="summary-cards mb-4">
      <b-row>
        <b-col md="2">
          <b-card class="summary-card">
            <div class="summary-item">
              <h4>Total Number Of Guests</h4>
              <p class="amount">{{totalGuests}}</p>
            </div>
          </b-card>
        </b-col>
        <b-col md="2">
          <b-card class="summary-card">
            <div class="summary-item">
              <h4>Total Number Of Bookings</h4>
              <p class="amount">{{totalBookings}}</p>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div class="section">
      <h4 class="section-title"><i class="bi bi-box-arrow-in-right"></i> Guests</h4>
      <div v-if="!groupedGuests || groupedGuests.length === 0" class="text-center p-4">
        <p class="mb-0">No data found for the selected criteria.</p>
      </div>
      <b-table
        v-else
        :items="groupedGuests"
        :fields="guestFields"
        class="mt-3"
        striped hover small responsive   
        :row-class="rowClass"
        :per-page="0"
        :current-page="currentPage"
      >
        <template #cell(booking_id)="data">
          <template v-if="data.item.isGroupHeader">
            <strong>#{{ data.item.booking_id }}</strong>
          </template>
          <template v-else>

          </template>
        </template>
        <template #cell(precheckin_sent)="data">
          <b-badge :variant="getStatusVariant(data.item.precheckin_sent)">
            {{ fetchPreCheckInStatus(data.item.precheckin_sent) }}
          </b-badge>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="guests.length"
        :per-page="perPage"
        class="mt-3"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { request } from '@/Util/Request';
const PRE_CHECK_IN_STATUS_OPTIONS = [
  { value: null, text: 'Select' },
  { value: 0, text: 'Pending' },
  { value: 1, text: 'Sent' },
  { value: 2, text: 'Completed' }
];
export default {
  name: 'CheckInReport',
  data() {
    return {
      filters: {
        check_in_date: null,
        checkout_date: null,
        hotel_id: null,
        pre_check_in:null
      },
      guestFields: [
        { key: 'booking_id', label: 'Booking ID' },
        { key: 'name', label: 'Guest Name' },
        { key: 'hotel', label: 'Hotel' },
        { key: 'room_type_name', label: 'Room Type' },
        { key: 'check_in', label: 'Check-in' },
        { key: 'check_out', label: 'Check-out' },
        { key: 'precheckin_sent', label: 'Pre Check-In' },
      ],
      reportTitle:'Guest and Pre Check-in Report',
      preCheckInStatuses: PRE_CHECK_IN_STATUS_OPTIONS,
      perPage: 10,
      currentPage: 1,
    }
  },
  props: {
    guests: {
      type: Array,
      required: true
    },
    totalGuests: {
      type: Number,
      required: false,
      default:0
    },
    totalBookings: {
      type: Number,
      required: false,
      default:0
    },
    hotelOptions:{
      type: Array,
      required:true
    }

  },

  computed:{
    groupedGuests() {
      let result = [];
      let bookings = {};

      if(this.guests){
        const actualGuests  = this.guests;
        const start = (this.currentPage - 1) * this.perPage;
        const end = start + this.perPage;
        const paginatedGuests = actualGuests.slice(start, end);
        paginatedGuests.forEach(guest => {
          const id = guest.booking_id
          if (!bookings[id]) {
            bookings[id] = [];
            result.push({ isGroupHeader: true, booking_id: id }) // push group row
          }
          result.push(guest)
        })
      }
      return result;
    },
  },
  methods: {
    fetchGuestList(){
      this.$emit('get-guest-list',this.filters);
    },
    async exportReport(format) {
      try {
        const params = {...this.filters,format: format};
        console.log(params);
        const response = await request({
          url: `/reports/guests/export`,
          method: 'GET',
          params: params,
          responseType: 'blob',
        });

        const mimeType = format === 'csv' 
          ? 'text/csv' 
          : 'application/pdf';
        
        const blob = new Blob([response], { type: mimeType });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', `guests_report.${format}`);
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.$bvToast.toast(`Report exported successfully as ${format.toUpperCase()}`, {
          title: 'Success',
          variant: 'success',
          solid: true
        });
      } catch (error) {
        console.error('Export failed:', error);
        this.$bvToast.toast('Error exporting report', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    },
    rowClass(item) {
      return item.isGroupHeader ? 'table-primary' : ''
    },
    fetchPreCheckInStatus(status){
      const option = this.preCheckInStatuses.find(opt => opt.value === status);
      return option ? option.text : '';
    },
    getStatusVariant(status){
      switch(status){
        case 2: return 'badge bg-success text-white';
        case 0: return 'badge bg-warning text-dark';
        case 1: return 'badge bg-secondary text-white';
      }
    }
  },
}
</script>

<style>
.filters-section {
  background: #f8fafc;
  border-radius: 8px;
}

.summary-cards {
  margin-bottom: 2rem;
}

.summary-card {
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  transition: transform 0.2s;
}

.summary-card:hover {
  transform: translateY(-2px);
}

.summary-item {
  text-align: center;
}

.summary-item h4 {
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.summary-item .amount {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
}

.summary-item .amount.positive {
  color: #059669;
}

.summary-item .amount.negative {
  color: #dc2626;
}

.summary-item .period {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2563eb;
  margin: 0;
}

.amount.positive {
  color: #059669;
  font-weight: 600;
}

.amount.negative {
  color: #dc2626;
  font-weight: 600;
}

.percentage {
  font-weight: 600;
  color: #6b7280;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.75em;
  font-size: 0.85em;
  font-weight: 600;
  border-radius: 999px;
  text-transform: capitalize;
  letter-spacing: 0.02em;
}

.bg-success {
  background: #22c55e !important;
  color: #fff !important;
}

.bg-warning {
  background: #fbbf24 !important;
  color: #222 !important;
}

.bg-danger {
  background: #ef4444 !important;
  color: #fff !important;
}

.bg-secondary {
  background: #6b7280 !important;
  color: #fff !important;
}

.date-picker {
  min-width: 150px;
}

@media (max-width: 768px) {
  .report-title {
    font-size: 1.1rem;
  }
  
  .summary-item .amount {
    font-size: 1.25rem;
  }
}
</style>